module.exports = __webpack_public_path__ + "img/dynamic-25.af5d3065.png";